import React from 'react';
import Immutable from 'immutable';

import type { SearchAllMembersHit } from '../types';
import MemberTeaser from '../../../implementations/Node/Member/Teaser';

const renderItem = (hit: SearchAllMembersHit) => {
  /* eslint-disable @typescript-eslint/naming-convention */
  const {
    url,
    title,
    website,
    address_line1,
    postal_code,
    address_locality,
    telephone_number,
    email,
  } = hit;
  /* eslint-enable @typescript-eslint/naming-convention */

  const hitUrl = url[0];

  return (
    <div className="SearchAllContentResults">
      <MemberTeaser
        className="testMember"
        entity={Immutable.fromJS({
          paths: {
            nl: hitUrl,
          },
          title: [{
            value: title,
          }],
          field_website: [{
            uri: website?.[0],
          }],
          field_telephone_number: [{
            value: telephone_number,
          }],
          field_email: [{
            value: email,
          }],
          field_address: [{
            address_line1,
            postal_code,
            locality: address_locality,
          }],
        })}
      />
    </div>
  );
};

export default renderItem;
